import React from "react";

const PaintbrushLightIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.75 4.5V5.25C5.75 5.51522 5.85536 5.76957 6.04289 5.95711C6.23043 6.14464 6.48478 6.25 6.75 6.25H15.25C15.5152 6.25 15.7696 6.14464 15.9571 5.95711C16.1446 5.76957 16.25 5.51522 16.25 5.25V3.75C16.25 3.48478 16.1446 3.23043 15.9571 3.04289C15.7696 2.85536 15.5152 2.75 15.25 2.75H6.75C6.48478 2.75 6.23043 2.85536 6.04289 3.04289C5.85536 3.23043 5.75 3.48478 5.75 3.75V4.5ZM5.75 4.5H4.75C4.48478 4.5 4.23043 4.60536 4.04289 4.79289C3.85536 4.98043 3.75 5.23478 3.75 5.5V8.75C3.75 9.01522 3.85536 9.26957 4.04289 9.45711C4.23043 9.64464 4.48478 9.75 4.75 9.75H8C8.53043 9.75 9.03914 9.96071 9.41421 10.3358C9.78929 10.7109 10 11.2196 10 11.75V13.75M10 13.75H9C8.73478 13.75 8.48043 13.8554 8.29289 14.0429C8.10536 14.2304 8 14.4848 8 14.75V17.25M10 13.75H11C11.2652 13.75 11.5196 13.8554 11.7071 14.0429C11.8946 14.2304 12 14.4848 12 14.75V17.25",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(PaintbrushLightIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;